import { useEffect, useState } from 'react';
import { getCmsDataInfo } from '../../../../api/pages/paddleCmsGetDataApi';
import { ITable } from './type';

const useHardware = () => {
    const [data, setData] = useState<ITable[]>([]);

    useEffect(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/localization' }).catch(err => console.log(err));
            if (res) {
                const data = res.body.result?.pageData || {};
                data?.Localization?.tableList && setData(data?.Localization?.tableList);
            }
        })();
    }, []);
    return { data };
};

export default useHardware;
